var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { triggerContractByContractName, viewContractByContractName, getContractAddressAndAbiByContractName, } from "../../../utils/tronweb/contractHelper";
import { resultToHexNumber } from "../../../utils/tronweb/utils";
export const lotteryGetPointsBalance = (landId, provider, account, callback) => __awaiter(void 0, void 0, void 0, function* () {
    const results = yield viewContractByContractName(landId, provider, "userPoints", "pointsBalanceOf", [account], callback);
    return resultToHexNumber(results);
});
export const lotteryPlayWithTicket = (landId, signer, type, callback) => {
    const methodName = type === "s" ? "playWithSmallTicket" : "playWithLargeTicket";
    return triggerContractByContractName(landId, signer, "lottery", methodName, [], callback);
};
export const lotteryGetTotalRewardInPool = (landId, provider, callback) => __awaiter(void 0, void 0, void 0, function* () {
    const ring = getContractAddressAndAbiByContractName(landId, provider, "ring");
    const results = yield viewContractByContractName(landId, provider, "lottery", "totalRewardInPool", [ring.address], callback);
    return resultToHexNumber(results);
});
